import {
  Box,
  CircularProgress,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
  alpha,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import Image from 'next/image'
import React, { ReactNode } from 'react'
import { useModal, create, muiDialogV5, register } from '@ebay/nice-modal-react'
import { toast } from 'react-toastify'
import Dialog from '../Dialog'
import { BtcConnectorName } from '@/context/BtcContext/types'
import { useBtc } from '@/context/BtcContext'
import { UserRejectError } from '@/context/BtcContext/errors'

const wallets: { icon: ReactNode; connectorName?: BtcConnectorName; title: string }[] = [
  {
    icon: <Image src="/wallets/unisat.jpg" alt="Unisat" width={36} height={36} />,
    title: 'Unisat',
    connectorName: 'Unisat',
  },
  {
    icon: <Image src="/wallets/okx.png" alt="OKX" width={36} height={36} />,
    title: 'OKX',
    connectorName: 'OKX',
  },
  {
    icon: <Image src="/wallets/xverse.jpg" alt="Xverse" width={36} height={36} />,
    title: 'Xverse (Soon)',
  },
  {
    icon: <Image src="/wallets/hiro.jpg" alt="Hiro" width={36} height={36} />,
    title: 'Hiro (Soon)',
  },
]

interface BitcoinWalletConnectDialogProps {
  onConnect?: () => void
}

export const BitcoinWalletModalKey = 'bitcoin-wallet-connect-dialog'
const BitcoinWalletConnectDialog = create(({ onConnect }: BitcoinWalletConnectDialogProps) => {
  const modal = useModal()

  const { isConnecting, connect, connectorName } = useBtc()
  const theme = useTheme()
  const isMD = useMediaQuery(theme.breakpoints.up('md'))
  return (
    <Dialog {...muiDialogV5(modal)}>
      <div>
        <Stack direction="row" spacing={12} sx={{ height: 44 }} alignItems="center">
          <Typography sx={{ textTransform: 'capitalize', fontSize: 18 }}>Connect your wallet</Typography>
        </Stack>

        <Stack spacing={12} sx={{ mt: 16 }}>
          {wallets.map((wallet) => (
            <ListItemButton
              key={wallet.title}
              sx={{
                bgcolor: (theme) => alpha(theme.palette.common.white, 0.1),
                borderRadius: '6px',
                overflow: 'hidden',
                py: 12,
                width: 300,
              }}
              disabled={!wallet.connectorName || isConnecting}
              onClick={async () => {
                if (!isMD && wallet.connectorName === 'Unisat') {
                  toast.warning('Please use a computer to perform this operation.')
                  modal.hide()
                } else {
                  try {
                    await connect(wallet.connectorName)
                    onConnect?.()
                  } catch (error) {
                    if (error?.code === UserRejectError.code) {
                      return
                    }

                    toast.error(error.message)
                  }
                }
              }}
            >
              <ListItemAvatar>
                <Box sx={{ borderRadius: '10px', overflow: 'hidden', width: 36, height: 36 }}>{wallet.icon}</Box>
              </ListItemAvatar>

              <ListItemText primary={wallet.title} />

              {isConnecting && connectorName === wallet.connectorName ? <CircularProgress size={16} /> : null}
            </ListItemButton>
          ))}
        </Stack>
      </div>
    </Dialog>
  )
})
register(BitcoinWalletModalKey, BitcoinWalletConnectDialog)
export default BitcoinWalletConnectDialog
